<template lang="html">
    <form @submit.prevent="submit()" class="form">
        <div class="form__items">
            <label class="form-item">
                <span class="form-item__label">Электронная почта</span>
                <div class="default-input">
                    <input v-model="email" type="email" name="email" required placeholder="Введите e-mail" />
                </div>
            </label>
			<label class="form-item">
				<XInputCheckbox
					v-model="agreement"
					:text="`Даю своё <a href='${policyLink}' target='_blank'>согласие на обработку персональных данных ООО «РК-Сервис»</a>`"
					required
				/>
			</label>
        </div>
        <div class="form__bottom">
            <button class="btn" :class="{ disabled : !email || !agreement }" >Подтвердить</button>
        </div>
    </form>

    <popup-block ref="completePopup" type="right" >
        <div class="popup__title">
            <h2 class="popup__title-title">Информация сохранена</h2>
        </div>
        <p class="popup__text popup__text--bold">
            Спасибо. Мы уведомим вас о поступлении данного товара на склад.
        </p>
    </popup-block>
</template>

<script>
import { availabilitySubscribe } from '../api';
import { ref } from 'vue';
import XInputCheckbox from "@/components/inputs/XInputCheckbox.vue";

export default {
    name : 'AvailabilitySubscribe',
	components: {XInputCheckbox},
    props : {
        productId : {
            type : [ String, Number ],
            default : '',
        },
		policyLink: String,
    },
    emits : [ 'sended' ],
    setup (props, { emit }) {
        const email = ref('');
        const agreement = ref(false);
        const completePopup = ref(null);
        const submit = () => {
            if (!email.value || !agreement.value)
                return;

            availabilitySubscribe(props.productId, email.value).then(res => {
                if (res.success) {
                    emit('sended');
                    completePopup.value.open();
                }
            });
        }
        return {
            email,
            submit,
            completePopup,
			agreement,
        }
    }
}
</script>
